import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  font-family: 'Courier New', monospace;
  background: #fff;
  color: #000;
  height: 100vh;
`;

export const MainContent = styled.div`
  margin-left: clamp(220px, 15vw, 300px);
  padding: 48px 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: margin-left 0.3s ease-in-out;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 24px 16px;
  }
`;
